<div class="cv-import-modal-component" *ngIf="isOpen">
	<div class="cv-approve-box">
		<div class="modal-body">
			<p class="msg-duplicate">
				{{ canImport ? confirmationMsg : confirmationNoDelete }}
			</p>
		</div>
		<div class="modal-footer">
			<button
				type="button"
				class="btn btn-secondary"
				data-dismiss="modal"
				(click)="closeImporBox()"
			>
				Cancel
			</button>
			<button type="button" class="btn btn-primary" (click)="openOrder()">Go to order</button>
			<button type="button" class="btn btn-primary" (click)="importOrder()" *ngIf="canImport">
				Import Order
			</button>
		</div>
	</div>
</div>
